var $98f2907c0694c5b6$exports = {};
$98f2907c0694c5b6$exports = {
  "pending": "afventende"
};
export { $98f2907c0694c5b6$exports as default };